require('./js');



// WEBPACK FOOTER //
// ./src/index.js